import { useCallback } from 'react'

import { localStorageRemove } from '@taxfix/scouts-helpers'

import { unloadIntercom } from '@/actions'
import { useAppDispatch } from '@/store'
import { useEventTracking } from '@/telemetry'
import { resetTracking, track, TRACK_USER_RESET_SESSION } from '@/trackers'

export const useResetSession = () => {
    const dispatch = useAppDispatch()

    const { unidentify } = useEventTracking()

    const resetSession = useCallback(() => {
        localStorageRemove('self_assessment_id')

        track(TRACK_USER_RESET_SESSION)

        resetTracking()
        unidentify()

        dispatch(unloadIntercom())
    }, [dispatch, unidentify])

    return { resetSession }
}
